import LeftArrow from "Assets/Icons/LeftArrow";
import Typography from "Components/CommonComponents/Typography";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { MainPageDiv } from "utilFunctions/shared/StyledComponent/StyledComponent";
import { UserInfoContext } from "Context/CommonContext";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import {
  BASE_URL,
  DEVELOPER_LECTUREACCESS,
} from "utilFunctions/Constants/urlConstants";
import NotiificationNoDataIcon from "Assets/Icons/NotificationNoDataIcon";
import { Table, Form, Checkbox, Button } from "antd";
import { AxiosInstance } from "utilFunctions/Axios/AxiosRequest";
import CheckIcon from "Assets/Icons/CheckIcon";
import CrossIcon from "Assets/Icons/CrossIcon";
import styled, { css } from "styled-components";
const StyledSpan = styled<any>("span")`
  color: var(--Grey-60, #757575);
  font-size: ${({ screen }: any) =>
    ["xxl", "xl", "lg"].includes(screen) ? "16px" : "8px"};
  font-style: normal;
  font-weight: 400;
  margin-top: 16px;
`;
const StyledDiv = styled<any>("div")`
  border-radius: ${({ screen }: any) =>
    ["xxl", "xl", "lg"].includes(screen) ? "8px" : "0px"};
  background: #fff;
  padding: 16px;
  height: ${({ screen }: any) =>
    ["xxl", "xl", "lg"].includes(screen)
      ? "calc(100vh - 167px)"
      : "calc(100vh - 126px)"};
  overflow: auto;
`;
export const StyledMainDiv = styled.div<{ screen: string; customCss?: any }>`
  background: #fff;
  padding: 16px;
  display: flex;
  align-items: center;
  color: var(--Grey-80, #333);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  border-radius: ${({ screen }) =>
    ["xxl", "xl", "lg"].includes(screen) ? "8px" : "0px"};
  position: sticky;
  top: 0;
  z-index: 10; /* keeps it above the table */

  ${({ customCss }) =>
    customCss &&
    css`
      ${customCss}
    `}
`;

const DeveloperToolsMain = (props: any) => {
  const { height } = props;
  const { screen }: any = useWindowSize();
  const [lectureAccessData, setLectureAccessData] = useState<any>([]);
  const navigate = useNavigate();
  const userInfo = useContext<any>(UserInfoContext);
  const [offset, setOffSet] = useState<number>(0);
  const [form] = Form.useForm();
  const [editingKey, setEditingKey] = useState("");
  const [saveLoading, setSaveLoading] = useState(false);

  const { makeRequest: GetLectureAccessData, loading: pageLoading } = useGetApi(
    (searchData: any) => {
      if (
        searchData &&
        searchData != null &&
        searchData["data"] &&
        searchData["data"].length
      ) {
        setLectureAccessData(searchData["data"]);
      }
    },
    (error: any) => {
      onFetchError(error);
    }
  );

  const onFetchError = (error: any) => {
    console.log("erorr onFetchError", error);
    if (offset === 0) {
      // setSuggestions([]);
    } else {
      setOffSet(0);
    }
  };

  useEffect(() => {
    if (userInfo.employeeId) {
      const url = BASE_URL + DEVELOPER_LECTUREACCESS;
      GetLectureAccessData(url);
    }
  }, [userInfo]);

  const isEditing = (record: any) => record.role === editingKey;

  const edit = (record: any) => {
    form.setFieldsValue({ ...record });
    setEditingKey(record.role);
  };

  const cancel = () => {
    setEditingKey("");
  };

  const save = async (role: string) => {
    try {
      setSaveLoading(true);
      const row = await form.validateFields();
      const newData = [...lectureAccessData];
      const index = newData.findIndex((item) => role === item.role);
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...row });
        const url = BASE_URL + DEVELOPER_LECTUREACCESS;
        await AxiosInstance.postPostRequest(url, newData[index], "put");
        setLectureAccessData(newData);
        setEditingKey("");
      } else {
        // This case should not happen in this UI
      }
    } catch (errInfo) {
      console.log("Validate Failed:", errInfo);
    } finally {
      setSaveLoading(false);
    }
  };

  const columns = [
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
    },
    ...Object.keys(lectureAccessData[0] || {})
      .filter((key) => typeof (lectureAccessData[0] || {})[key] === "boolean")
      .map((key) => ({
        title: key.charAt(0).toUpperCase() + key.slice(1),
        dataIndex: key,
        key: key,
        render: (text: boolean, record: any) => {
          const editable = isEditing(record);
          return editable ? (
            <Form.Item name={key} valuePropName="checked" noStyle>
              <Checkbox />
            </Form.Item>
          ) : text ? (
            <CheckIcon fill="green" width="18" height="18" />
          ) : (
            <CrossIcon fill="red" width="18" height="18" />
          );
        },
      })),
    {
      title: "Action",
      key: "action",
      width: "220px",
      render: (_: any, record: any) => {
        const editable = isEditing(record);
        return editable ? (
          <span>
            <Button
              onClick={() => save(record.role)}
              style={{ marginRight: 8 }}
              loading={saveLoading}
              type="primary"
            >
              Save
            </Button>
            <Button onClick={cancel}>Cancel</Button>
          </span>
        ) : (
          <Button disabled={editingKey !== ""} onClick={() => edit(record)}>
            Edit
          </Button>
        );
      },
    },
  ];
  console.log(lectureAccessData, "lectureAccessData", height);

  return (
    <MainPageDiv screen={screen}>
      <StyledMainDiv screen={screen}>
        <LeftArrow
          className={"cursorHoverCSS mr-3"}
          onClick={() => {
            navigate("/admin/dashboard", {
              replace: true,
              state: {
                selectedStudent: null,
              },
            });
          }}
        />
        <Typography variant={"h6"} color="black">
          Lecture Asset Access
        </Typography>
      </StyledMainDiv>
      {lectureAccessData && lectureAccessData.length && !pageLoading ? (
        <StyledDiv screen={screen}>
          <Form form={form} component={false}>
            <Table
              components={{
                body: {
                  cell: (props: any) => <td {...props} />,
                },
              }}
              bordered
              dataSource={lectureAccessData}
              columns={columns}
              rowClassName="editable-row"
              pagination={{
                onChange: cancel,
              }}
              rowKey="role"
            />
          </Form>
        </StyledDiv>
      ) : (
        <StyledDiv screen={screen}>
          <div
            className={
              "d-flex justify-content-center align-items-center flex-column h-100"
            }
            style={{
              background: "#F5F5F5",
            }}
          >
            <div>
              <NotiificationNoDataIcon />
            </div>
            <div className="d-flex align-items-center flex-column">
              <StyledSpan screen={screen}>
                LectureAccess data not available
              </StyledSpan>
            </div>
          </div>
        </StyledDiv>
      )}
    </MainPageDiv>
  );
};

export default DeveloperToolsMain;
